module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x3_256.d93b40e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x3_256.png
// module id = bjVq
// module chunks = 0